import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


const initialState = {
    license: null,
    licenses: [],
    loading: false,
    licenseList: [],
    listLoading: false,
    apiConfig: null
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
